import { render, staticRenderFns } from "./multiple-product.vue?vue&type=template&id=6c72b05c&"
import script from "./multiple-product.vue?vue&type=script&lang=js&"
export * from "./multiple-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c72b05c')) {
      api.createRecord('6c72b05c', component.options)
    } else {
      api.reload('6c72b05c', component.options)
    }
    module.hot.accept("./multiple-product.vue?vue&type=template&id=6c72b05c&", function () {
      api.rerender('6c72b05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/field-template/multiple-product.vue"
export default component.exports